<h3 class="mb-0 p-3 align-self-center" data-cy="pageTitle">Frequently Asked Questions</h3>
<div class="m-4">
  <div *ngFor="let item of items" class="card mb-3">
    <div *ngIf="!item.tenant || item.tenant === tenantId" class="card-body pb-1">
      <h5>{{ item.title }}</h5>
      <p [innerHTML]="item.body"></p>
    </div>
  </div>
</div>
